/* eslint-disable  */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { refund } from "../../../../api/Api";

export const getAllRefund = createAsyncThunk(
  "appRefund/getAllRefund",
  async (values) => {
    try {
      return refund.getAll(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const appRefundSlice = createSlice({
  name: "appRefund",
  initialState: {
    refund: [],
    refundFetch: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllRefund.fulfilled, (state, action) => {
      state.refund = action.payload?.data;
      state.refundFetch = true;
    });
  },
});

export default appRefundSlice.reducer;
